import { Box } from "@mantine/core";

import Flex from "components/Flex";
import { CarDiagram } from "components/VehicleImpact/CarDiagram";
import { useStyles } from "components/VehicleImpact/styles";

import { DJImpactSelectors } from "./DJImpactSelectors";
import { MotoDiagram } from "./MotoDiagram";

interface DJVehicleImpactProps {
  editable?: boolean;
  isCar?: boolean;
}

export const DJVehicleImpact: React.FC<DJVehicleImpactProps> = ({ editable = true, isCar = true }) => {
  const { classes } = useStyles({ editable });

  return (
    <Flex flex={1} align="center">
      <Box className={classes.carPictureContainer}>
        <DJImpactSelectors editable={editable} showRoofPOI={isCar === true} />

        {isCar === true || isCar === undefined ? (
          <CarDiagram alt="Top of car for selecting point of impact" className={classes.carPicture} />
        ) : (
          <MotoDiagram alt="Top of motorcycle for selecting point of impact" className={classes.carPicture} />
        )}
      </Box>
    </Flex>
  );
};
